module.exports = __webpack_public_path__ + "static/form-study-16x9-2d1c2a3e40a1f2407af48e135c06b4b8.jpg";